/*
 * Copyright © 2024-2026 symecode.com. All rights reserved.
 * 
 * This source code is proprietary and confidential.
 * Unauthorized copying, modification, or distribution is prohibited.
 */


import React from 'react';
import './InsufficientCreditsModal.css';

interface InsufficientCreditsModalProps {
  costFormatted: string;
  creditsFormatted: string;
  onPayWithStripe: () => void;
  onCancel: () => void;
}

const InsufficientCreditsModal: React.FC<InsufficientCreditsModalProps> = ({
  costFormatted,
  creditsFormatted,
  onPayWithStripe,
  onCancel
}) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content insufficient-credits-modal">
        <h2>Insufficient Credits</h2>

        <div className="modal-body">
          <p className="warning-message">
            You do not have enough credits to generate this bid.
          </p>
          <div className="credits-breakdown">
            <div className="breakdown-item">
              <span className="label">Required:</span>
              <span className="value">{costFormatted}</span>
            </div>
            <div className="breakdown-item">
              <span className="label">Available:</span>
              <span className="value">{creditsFormatted}</span>
            </div>
          </div>
          <p className="payment-prompt">
            You will need to purchase credits to continue.
          </p>
        </div>

        <div className="modal-actions">
          <button
            className="cancel-button"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="pay-button"
            onClick={onPayWithStripe}
          >
            Continue to Payment
          </button>
        </div>
      </div>
    </div>
  );
};

export default InsufficientCreditsModal;
